import { useMemo } from 'react';
import { useTranslation } from '@shared/core';
import type { ChildAgeValidationMessages } from './occupancySchema';

export const useChildAgeValidation = (): ChildAgeValidationMessages => {
  const { tq } = useTranslation('stays');

  return useMemo(
    () => ({
      childAgeInvalid: tq`Provide the age of child`,
      childAgeRequired: tq`Provide the age of child`,
      childAgeMin: tq`Age must be at least 0`,
      childAgeMax: tq`Age must be 17 or under`,
    }),
    [tq],
  );
};
